import Create from './Create'
import CreateTrigger from './CreateTrigger'
import Thumbnail from './Thumbnail'
import Preview from './Preview'

export default {
  name: 'YouTube',
  condition: x => {
    return /^youtube/i.test(x.type)
  },
  components: {
    Create,
    CreateTrigger,
    Thumbnail,
    Preview,
  },
}
